// The standing disclaimer the domain rules require, as a brass plate along the bottom edge of every room. On a phone
// the plate keeps to one line inside the 36 px the rooms leave clear: the required sentence stays on the plate, the
// second sentence is still read out to screen readers (hud.css, .footer-more).
export default function Footer() {
  return (
    <footer className="footer-strip">
      <p>AI simulation for educational purposes.<span className="footer-more"> Not the views of any sitting Justice.</span></p>
    </footer>
  );
}
